import imageChartCrz from "./../../../../assets/image_chart__crz.svg";
import imageChartBarHor from "./../../../../assets/image_chart_bar_hor.svg";
import imageChartBarVer from "./../../../../assets/image_chart_bar_ver.svg";
import imageChartDon from "./../../../../assets/image_chart_don.svg";
import imageChartLine from "./../../../../assets/image_chart_line.svg";
import imageChartTree from "./../../../../assets/image_chart_tree.svg";
import imageChartGrid from "./../../../../assets/image_chart_grid.svg";

import iconLayoutOne from "./../../../../assets/layoult_one.svg";
import iconLayoutTwo from "./../../../../assets/layoult_two.svg";

import {
  SizesItemInLayout,
  TypesRepresentation,
} from "../../../../@types/chart.type";
import styles from "./styles.module.scss";

interface RepresentationCardProps {
  name: string;
  type: TypesRepresentation;
  sizeInLayout: SizesItemInLayout;
  description: string;
}

export function RepresentationCard({
  name,
  sizeInLayout,
  type,
  description,
}: RepresentationCardProps) {
  function displayImageFromChart(type: TypesRepresentation) {
    switch (type) {
      case "line":
        return imageChartLine;
      case "barVertical":
        return imageChartBarVer;
      case "barHorizontal":
        return imageChartBarHor;
      case "donnut":
        return imageChartDon;
      case "cross":
        return imageChartCrz;
      case "grid":
        return imageChartGrid;
      default:
        return imageChartTree;
    }
  }

  return (
    <div className={styles.representationCard}>
      <div className={styles.texts}>
        <h3 title={name}>{name}</h3>
        <p title={description}>{description}</p>
      </div>
      <div className={styles.images}>
        <div className={styles.imageLayout}>
          <img
            src={sizeInLayout === "one" ? iconLayoutOne : iconLayoutTwo}
            alt=""
          />
        </div>
        <div className={styles.imageChart}>
          <img src={displayImageFromChart(type)} alt="" />
        </div>
      </div>
    </div>
  );
}
